'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "BlockStack": "Polaris-BlockStack",
  "listReset": "Polaris-BlockStack--listReset",
  "fieldsetReset": "Polaris-BlockStack--fieldsetReset"
};

exports.default = styles;
